// Simple user info utilities with sessionStorage persistence, mirroring token util behavior.
// Stores non-sensitive profile attributes provided at login to personalize UI.

const STORAGE_KEY = 'auth_user';

export interface StoredUserInfo {
  username: string | null;
  givenName: string | null;
  familyName: string | null;
}

let inMemoryUser: StoredUserInfo | null = null;

export function getUserInfo(): StoredUserInfo {
  if (inMemoryUser) return inMemoryUser;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      inMemoryUser = { username: null, givenName: null, familyName: null };
      return inMemoryUser;
    }
    const parsed = JSON.parse(raw) as StoredUserInfo;
    inMemoryUser = {
      username: parsed?.username ?? null,
      givenName: parsed?.givenName ?? null,
      familyName: parsed?.familyName ?? null,
    };
    return inMemoryUser;
  } catch {
    // sessionStorage may be unavailable; fall back to memory only.
    if (!inMemoryUser) inMemoryUser = { username: null, givenName: null, familyName: null };
    return inMemoryUser;
  }
}

export function setUserInfo(info: StoredUserInfo | null): void {
  inMemoryUser = info;
  try {
    if (info) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(info));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Ignore storage errors; we still keep in-memory value.
  }
}
